import { Injectable } from '@angular/core';
import { HasPermissionGuard } from './has-permission.guard';
import { ViewSubjects } from '@sharedlib/common/permissions/types/Permissions';

@Injectable({
  providedIn: 'root',
})
export class ContactsAppGuard extends HasPermissionGuard {
  constructor() {
    super('read', ViewSubjects.contactsView);
  }
}
